/** Pure UI hint: the angle (radians) of the in-progress snap drag, or
 *  null when no snap is active. Tools that call snapToCommonAngle push
 *  the chosen angle here so the bottom-left chip can show "30°" / "45°"
 *  / etc. while the drag is happening, then push null on pointer-up /
 *  cancel / tool-deactivate.
 *
 *  Kept as a tiny standalone module rather than wired through
 *  EditorContext: this is a transient render hint, not a tool/setting,
 *  and threading it through the editor would obscure the intent. */

let current: number | null = null;
const listeners = new Set<(v: number | null) => void>();

export function setAngleHint(rad: number | null): void {
  if (current === rad) return;
  current = rad;
  for (const fn of listeners) fn(rad);
}

export function onAngleHintChange(
  fn: (rad: number | null) => void,
): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
